import React, { useState } from 'react';
import { Card, ConsultantsSVG, HeaderTitle } from '../../components';
import { ConsultantsUIProvider } from './context/ConsultantsUIContext';
import ConsultantsSection from './components/ConsultantsSection';
import ClientDropHeader from '../clients/makeandchecker/ClientDropHeader';
import ClientsDropMenu from '../clients/makeandchecker/ClientsDropMenu';
import { useTranslation } from 'react-i18next';

export default function Consultants () {
    const { t } = useTranslation();
    // eslint-disable-next-line no-unused-vars
    const [total, setTotal] = useState({ clientsDropBadges: 0 });

    // Main Component

    return (
        <ConsultantsUIProvider>
            <div className='functionalitiesPage'>
                <ClientDropHeader />
                <div className='menuFlex'>
                    <div className='menuFlexLeft'>
                        <ClientsDropMenu clientsDropBadges={total.clientsDropBadges}/>
                    </div>
                    <div className='menuFlexRight'>
                        <Card style={{ height: '750px' }}>
                            {/* <CardHeader title={t('management.consultants.subTitle')} icon={<ConsultantsSVG size = {20} />}/> */}
                            <HeaderTitle
                                title={t('management.consultants.subTitle')}
                                icon={<ConsultantsSVG />}
                                margBottom={'1rem'}
                            />

                            <div className="d-flex flex-column px-4 overflow-auto h-100">
                                <ConsultantsSection />
                            </div>
                        </Card>
                    </div>
                </div>
            </div>
        </ConsultantsUIProvider>
    );
}
